import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { Home } from './pages/Home';
import { ModelHomes } from './pages/ModelHomes';
import { Articles } from './pages/Articles';
import { Magazine } from './pages/Magazine';
import { Visit } from './pages/Visit';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkx2pb6487kw">
      <Routes data-id="element-1" data-mp="2rkdvaoe3d1l4">
        <Route element={<SiteLayout data-id="element-3" data-mp="2rlp0msn6qhec" />} data-id="element-2" data-mp="2rlyreig20sl3">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mlu5ue0ah7o0" />} data-id="element-4" data-mp="2rit1x23ijoou" />
          <Route path="/model-homes" element={<ModelHomes data-id="element-7" data-mp="2mndr6j0sy8wn" />} data-id="element-6" data-mp="2mmlsv0ftlx2o" />
          <Route path="/magazine" element={<Magazine data-id="element-9" data-mp="31b8fzobovt4g" />} data-id="element-8" data-mp="2mjzn96chprn3" />
          <Route path="/articles" element={<Articles data-id="element-11" data-mp="31ctaxf1x1e2u" />} data-id="element-10" data-mp="31bia9o3romfy" />
          <Route path="/visit" element={<Visit data-id="element-13" data-mp="2wiyvintcfl9k" />} data-id="element-12" data-mp="2wka0gqyiyz29" />
          <Route path="*" element={<Home data-id="element-15" data-mp="2wi5l9cv6edmo" />} data-id="element-14" data-mp="2wip6b2g4hi4x" />
        </Route>
      </Routes>
    </BrowserRouter>;
}